import type { TimeInRangeInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import dayjs from "dayjs"
import { useMemo } from "react"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileSpacer } from "./TileSpacer"
import { TileTimeValue } from "./TileTimeValue"
import { TileTitle } from "./TileTitle"
import { usePolyglot } from "src/contexts"
import { useThisMinute } from "src/hooks"

export function TimeInRange(props: TileProps<TimeInRangeInsight>) {
  const { insightKey } = props

  const polyglot = usePolyglot()
  const { timeInRangeCalculation } = useCalculationsContext()
  const thisMinute = useThisMinute()

  const value = useMemo(
    () => {
      if (timeInRangeCalculation === null || timeInRangeCalculation === undefined) {
        return null
      }

      if (timeInRangeCalculation === 0) {
        return 0
      }

      return dayjs(thisMinute).diff(
        timeInRangeCalculation,
        "minute",
        true,
      )
    },
    [
      thisMinute,
      timeInRangeCalculation,
    ],
  )

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileSpacer />
      <TileTimeValue
        id={`${insightKey}-value`}
        tileId={insightKey}
        timeInMinutes={value}
        dayAbbreviation={polyglot.t("time.day_abbreviation")}
        hourAbbreviation={polyglot.t("time.hour_abbreviation")}
        minuteAbbreviation={polyglot.t("time.minute_abbreviation")}
      />
    </>
  )
}
